import { render, staticRenderFns } from "./buildingData.vue?vue&type=template&id=174e559e&scoped=true&"
import script from "./buildingData.vue?vue&type=script&lang=js&"
export * from "./buildingData.vue?vue&type=script&lang=js&"
import style0 from "./buildingData.vue?vue&type=style&index=0&id=174e559e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e559e",
  null
  
)

export default component.exports